"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKGROUND_SHAPE = void 0;
/**
 * Name of Background Shape
 */
exports.BACKGROUND_SHAPE = 'element-background';
//# sourceMappingURL=constant.js.map